import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import downloadButtonInteraction from './downloadButtonInteraction';
import addUploadButton from './addUploadButton';
import addUserPageButton from './addUserPageButton';
import UploadBanner from './components/UploadBanner';
import { UploadActivity } from './handler/Uploader';

export { default as extend } from './extend';
export * from './components';

app.initializers.add('fof-upload', () => {
  // Leaving these here for now.
  // @see ./extend.ts
  User.prototype.viewOthersMediaLibrary = Model.attribute('fof-upload-viewOthersMediaLibrary');
  User.prototype.deleteOthersMediaLibrary = Model.attribute('fof-upload-deleteOthersMediaLibrary');
  User.prototype.uploadCountCurrent = Model.attribute('fof-upload-uploadCountCurrent');
  User.prototype.uploadCountAll = Model.attribute('fof-upload-uploadCountAll');
  User.prototype.uploadSharedFiles = Model.attribute('fof-upload-uploadSharedFiles');
  User.prototype.accessSharedFiles = Model.attribute('fof-upload-accessSharedFiles');

  //app.fileListState = new FileListState();

  addUploadButton();
  downloadButtonInteraction();
  addUserPageButton();

  // ============================================================
  // 先发布、后台上传 机制：
  // 发新帖时若 fof-upload 上传器正在传文件 → 提交的 discussion 带
  // `uploadPending` 标记 → 后端把帖子置为“仅自己可见”（is_approved=false），
  // 不执行 AI 审核。等全部文件传完、链接自动追加进帖子后（PATCH 带
  // `uploadComplete`），后端才对完整内容执行 AI 审核，通过才公开。
  // ============================================================
  extend(DiscussionComposer.prototype, 'data', function (data) {
    // 当前 composer 的编辑器上挂着 fof-upload 的 uploader
    const editor = app.composer && app.composer.editor;
    const uploader = editor && editor.uploader;

    if (uploader && (uploader.uploading || UploadActivity.isActive())) {
      data.uploadPending = true;
      // 记录发帖锚点时间：之后无论多久传完，都按这个时间点找目标帖(不再用10分钟窗口)
      uploader.pendingPublishAt = Date.now();
      // 记录：这个帖子发布时后台正在传文件 → 帖子已被后端置隐藏，
      // 需要在本批上传结束后（成功/取消/失败）触发一次 finalize 审核公开。
      uploader.pendingPublish = true;
    }

    return data;
  });

  // 上传状态横幅：有活跃上传时显示“请勿离开”提示 + 进度 + 已成功文件
  // 讨论页（帖子内）：pageContent 的 hero(100) 与 main(10) 之间插 priority 50
  extend(DiscussionPage.prototype, 'pageContent', function (items) {
    items.add('uploadBanner', UploadBanner.component({ activity: UploadActivity }), 50);
  });

  // 首页（讨论列表主界面）：contentItems 的 toolbar(100) 前插 priority 110
  extend(IndexPage.prototype, 'contentItems', function (items) {
    items.add('uploadBanner', UploadBanner.component({ activity: UploadActivity }), 110);
  });
});
